import { useEffect, useState } from 'react';
import { getCountDays } from '../helpers/getCountDays';
import moment from 'moment';
import { useEditCharter } from './useEditCharter';

export const useMoveCharter = (charter, activeTab) => {
    const [positionX, setPositionX] = useState(0);
    const [needMoveUpdate, setNeedMoveUpdate] = useState(false);

    const { updateAll, moveCharterNew } = useEditCharter(charter);

    const handleMouseMove = (value) => {
        setPositionX((prevState) => prevState + value);
    };

    const handleMouseUp = () => {
        setNeedMoveUpdate(true);
    };

    useEffect(() => {
        if (needMoveUpdate) {
            const oldStartDate = charter.planned.start_date ? charter.planned.start_date : '';
            const start_date = getCountDays(positionX, oldStartDate, activeTab);

            const dateDiff = moment(start_date).diff(oldStartDate, 'days');

            let resultUpdating = {};
            if (dateDiff !== 0) {
                const moveResult = moveCharterNew(dateDiff, resultUpdating);
                resultUpdating = { ...resultUpdating, ...moveResult };
                updateAll(resultUpdating);
            }

            setPositionX(0);
            setNeedMoveUpdate(false);
        }
    }, [needMoveUpdate]);

    return {
        positionX,
        handleMouseMove,
        handleMouseUp,
    };
};
